const CONSENT_STATUS = {
  0: "Denied",
  1: "Approved",
  2: "Pending",
  3: "Archived",
};

type ConsentType = 0 | 1 | 2 | 3;

export const getConsentStatusString = (consentStatus: ConsentType) =>
  CONSENT_STATUS[consentStatus];

export const EMPTY_DATA = {
  NA: "N/A",
  NDA: "No data available",
};
